/**
 * BB-TIER-CONFIG.js - Tier Intensity Configuration
 * 
 * Contains the TIER_INTENSITY settings that control:
 * - Shake/wobble animation parameters per tier
 * - Fire effect parameters (flames behind text)
 * - Text positioning for percent and savings displays
 * - Card visual effects (glow, flicker, idle intensity)
 * 
 * These values can be edited via the Debug Panel and exported/imported.
 * 
 * @version 1.0.0
 * @requires BB.Core
 */

window.BB = window.BB || {};

window.BB.TierConfig = (function() {
  'use strict';
  
  // ========================================================================
  // TIER INTENSITY PRESETS
  // Per-tier configuration for shake, fire, and visual effects
  // Tier 0 = no items, Tier 5 = max discount (5+ items)
  // ========================================================================
  var TIER_INTENSITY = {
    "0": {
      // Shake settings
      "shakeTravel": 0,
      "shakeRotation": 0.7,
      "shakeStagger": 0,
      "shakeSpeed": 105,
      
      // Card visual settings
      "idleIntensity": 0.05,
      "hoverGlow": 0.15,
      "selectedGlow": 0.15,
      "selectedFlicker": 0.05,
      
      // Hover wave settings
      "hoverTravel": 1.1,
      "hoverRotation": 0,
      "hoverDuration": 5000,
      "hoverStagger": 850,
      
      // Card wave settings
      "cardTravel": 1,
      "cardDuration": 5200,
      "cardStagger": 3050,
      
      // Pop animation settings
      "popScale": 1.6,
      "popDuration": 200,
      "popStagger": 50,
      
      // Fire effect - PERCENT display
      "fireSideFade": 0,
      "fireFlameHeight": 0,
      "fireScale": 0,
      "fireSpeedY": 0,
      "fireWobble": 0,
      "fireThreshold": 0,
      "fireDetail": 0,
      "fireAperture": 0,
      "fireSoftness": 0,
      "fireAlpha": 0,
      "fireColorTop": "#0093fe",
      "fireColorMid": "#00ffff",
      "fireColorBot": "#00ffff",
      "fireOffsetX": 0,
      "fireOffsetY": -131,
      "fireWidth": 100,
      "fireHeight": 185,
      
      // Fire effect - SAVINGS display
      "savingsFireColorTop": "#ff4c40",
      "savingsFireColorMid": "#fea948",
      "savingsFireColorBot": "#feffda",
      "savingsFireOffsetX": 24,
      "savingsFireOffsetY": -171,
      "savingsFireWidth": 75,
      "savingsFireHeight": 195,
      
      // Savings badge colors
      "savingsBgColor": "#fb4c45",
      "savingsShadowColor": "#b02823",
      
      // Text positioning
      "percentTextX": 0,
      "percentTextY": 0,
      "percentShadowX": 0,
      "percentShadowY": 3,
      "savingsTextX": -6,
      "savingsTextY": -1,
      "savingsShadowX": -2,
      "savingsShadowY": 7
    },
    
    "1": {
      "shakeTravel": 0,
      "shakeRotation": 1,
      "shakeStagger": 10,
      "shakeSpeed": 105,
      "idleIntensity": 0.05,
      "hoverGlow": 0.15,
      "selectedGlow": 0.15,
      "selectedFlicker": 0.05,
      "hoverTravel": 1.2,
      "hoverRotation": 0,
      "hoverDuration": 4400,
      "hoverStagger": 850,
      "cardTravel": 2,
      "cardDuration": 3000,
      "cardStagger": 2650,
      "popScale": 1.6,
      "popDuration": 200,
      "popStagger": 50,
      "fireSideFade": 1.38,
      "fireFlameHeight": 0.09,
      "fireScale": 0.05,
      "fireSpeedY": 0.017,
      "fireWobble": 0.05,
      "fireThreshold": 1.12,
      "fireDetail": 1.1,
      "fireAperture": 0.16,
      "fireSoftness": 0.111,
      "fireAlpha": 1,
      "fireColorTop": "#0093fe",
      "fireColorMid": "#0093fe",
      "fireColorBot": "#00ffff",
      "fireOffsetX": 1,
      "fireOffsetY": -59,
      "fireWidth": 100,
      "fireHeight": 150,
      "savingsFireColorTop": "#ff4c40",
      "savingsFireColorMid": "#fea948",
      "savingsFireColorBot": "#feffda",
      "savingsFireOffsetX": -16,
      "savingsFireOffsetY": -59,
      "savingsFireWidth": 125,
      "savingsFireHeight": 150,
      "savingsBgColor": "#fb4c45",
      "savingsShadowColor": "#b02823",
      "percentTextX": 0,
      "percentTextY": 0,
      "percentShadowX": 0,
      "percentShadowY": 3,
      "savingsTextX": -6,
      "savingsTextY": -1,
      "savingsShadowX": -2,
      "savingsShadowY": 7
    },
    
    "2": {
      "shakeTravel": 0,
      "shakeRotation": 2.2,
      "shakeStagger": 55,
      "shakeSpeed": 105,
      "idleIntensity": 0.1,
      "hoverGlow": 0.25,
      "selectedGlow": 0.25,
      "selectedFlicker": 0.1,
      "hoverTravel": 1.7,
      "hoverRotation": 0,
      "hoverDuration": 4400,
      "hoverStagger": 850,
      "cardTravel": 2,
      "cardDuration": 3000,
      "cardStagger": 2650,
      "popScale": 1.6,
      "popDuration": 200,
      "popStagger": 50,
      "fireSideFade": 0.74,
      "fireFlameHeight": 0.21,
      "fireScale": 0.05,
      "fireSpeedY": 0.03,
      "fireWobble": 0.05,
      "fireThreshold": 1.16,
      "fireDetail": 1,
      "fireAperture": 0.23,
      "fireSoftness": 0.112,
      "fireAlpha": 1,
      "fireColorTop": "#0093fe",
      "fireColorMid": "#00ffff",
      "fireColorBot": "#00ffff",
      "fireOffsetX": -3,
      "fireOffsetY": -66,
      "fireWidth": 100,
      "fireHeight": 165,
      "savingsFireColorTop": "#ff4c40",
      "savingsFireColorMid": "#fea948",
      "savingsFireColorBot": "#feffda",
      "savingsFireOffsetX": -17,
      "savingsFireOffsetY": -78,
      "savingsFireWidth": 125,
      "savingsFireHeight": 195,
      "savingsBgColor": "#fb4c45",
      "savingsShadowColor": "#b02823",
      "percentTextX": 0,
      "percentTextY": 0,
      "percentShadowX": 0,
      "percentShadowY": 3,
      "savingsTextX": 0,
      "savingsTextY": 0,
      "savingsShadowX": 0,
      "savingsShadowY": 3
    },
    
    "3": {
      "shakeTravel": 0,
      "shakeRotation": 2.2,
      "shakeStagger": 55,
      "shakeSpeed": 105,
      "idleIntensity": 0.1,
      "hoverGlow": 0.25,
      "selectedGlow": 0.25,
      "selectedFlicker": 0.1,
      "hoverTravel": 1.7,
      "hoverRotation": 0,
      "hoverDuration": 4400,
      "hoverStagger": 850,
      "cardTravel": 2,
      "cardDuration": 3000,
      "cardStagger": 2650,
      "popScale": 1.6,
      "popDuration": 200,
      "popStagger": 50,
      "fireSideFade": 0.68,
      "fireFlameHeight": 0.37,
      "fireScale": 0.05,
      "fireSpeedY": 0.035,
      "fireWobble": 0.05,
      "fireThreshold": 1.13,
      "fireDetail": 1,
      "fireAperture": 0.23,
      "fireSoftness": 0.111,
      "fireAlpha": 1,
      "fireColorTop": "#0093fe",
      "fireColorMid": "#00ffff",
      "fireColorBot": "#00ffff",
      "fireOffsetX": -4,
      "fireOffsetY": -66,
      "fireWidth": 105,
      "fireHeight": 165,
      "savingsFireColorTop": "#ff4c40",
      "savingsFireColorMid": "#fea948",
      "savingsFireColorBot": "#feffda",
      "savingsFireOffsetX": -16,
      "savingsFireOffsetY": -59,
      "savingsFireWidth": 125,
      "savingsFireHeight": 150,
      "savingsBgColor": "#fb4c45",
      "savingsShadowColor": "#b02823",
      "percentTextX": 0,
      "percentTextY": 0,
      "percentShadowX": 0,
      "percentShadowY": 3,
      "savingsTextX": 0,
      "savingsTextY": 0,
      "savingsShadowX": 0,
      "savingsShadowY": 3
    },
    
    "4": {
      "shakeTravel": 0,
      "shakeRotation": 2.6,
      "shakeStagger": 65,
      "shakeSpeed": 105,
      "idleIntensity": 0.12,
      "hoverGlow": 0.3,
      "selectedGlow": 0.3,
      "selectedFlicker": 0.12,
      "hoverTravel": 1.7,
      "hoverRotation": 0,
      "hoverDuration": 4400,
      "hoverStagger": 850,
      "cardTravel": 2,
      "cardDuration": 3000,
      "cardStagger": 2650,
      "popScale": 1.6,
      "popDuration": 200,
      "popStagger": 50,
      "fireSideFade": 0.44,
      "fireFlameHeight": 0.38,
      "fireScale": 0.05,
      "fireSpeedY": 0.04,
      "fireWobble": 0.05,
      "fireThreshold": 1.02,
      "fireDetail": 1.1,
      "fireAperture": 0.23,
      "fireSoftness": 0.111,
      "fireAlpha": 1,
      "fireColorTop": "#0093fe",
      "fireColorMid": "#00ffff",
      "fireColorBot": "#00ffff",
      "fireOffsetX": -4,
      "fireOffsetY": -66,
      "fireWidth": 110,
      "fireHeight": 165,
      "savingsFireColorTop": "#ff4c40",
      "savingsFireColorMid": "#fea948",
      "savingsFireColorBot": "#feffda",
      "savingsFireOffsetX": -12,
      "savingsFireOffsetY": -60,
      "savingsFireWidth": 115,
      "savingsFireHeight": 150,
      "savingsBgColor": "#fb4c45",
      "savingsShadowColor": "#b02823",
      "percentTextX": 0,
      "percentTextY": 0,
      "percentShadowX": 0,
      "percentShadowY": 3,
      "savingsTextX": 0,
      "savingsTextY": 0,
      "savingsShadowX": 0,
      "savingsShadowY": 3
    },
    
    "5": {
      "shakeTravel": 0.8,
      "shakeRotation": 6.1,
      "shakeStagger": 55,
      "shakeSpeed": 105,
      "idleIntensity": 0.15,
      "hoverGlow": 0.4,
      "selectedGlow": 0.4,
      "selectedFlicker": 0.15,
      "hoverTravel": 1.7,
      "hoverRotation": 0,
      "hoverDuration": 4400,
      "hoverStagger": 850,
      "cardTravel": 2,
      "cardDuration": 3000,
      "cardStagger": 2650,
      "popScale": 1.6,
      "popDuration": 200,
      "popStagger": 50,
      "fireSideFade": 0.5,
      "fireFlameHeight": 0.36,
      "fireScale": 0.05,
      "fireSpeedY": 0.05,
      "fireWobble": 0.05,
      "fireThreshold": 1.2,
      "fireDetail": 1.2,
      "fireAperture": 0.11,
      "fireSoftness": 0.188,
      "fireAlpha": 1,
      "fireColorTop": "#0093fe",
      "fireColorMid": "#00ffff",
      "fireColorBot": "#00ffff",
      "fireOffsetX": -2,
      "fireOffsetY": -78,
      "fireWidth": 105,
      "fireHeight": 195,
      "savingsFireColorTop": "#ff4c40",
      "savingsFireColorMid": "#fea948",
      "savingsFireColorBot": "#feffda",
      "savingsFireOffsetX": -12,
      "savingsFireOffsetY": -60,
      "savingsFireWidth": 115,
      "savingsFireHeight": 150,
      "savingsBgColor": "#ff4c45",
      "savingsShadowColor": "#b02823",
      "percentTextX": 0,
      "percentTextY": 0,
      "percentShadowX": 0,
      "percentShadowY": 3,
      "savingsTextX": 0,
      "savingsTextY": 0,
      "savingsShadowX": 0,
      "savingsShadowY": 3
    }
  };
  
  // ========================================================================
  // DEFAULT SHAKE SETTINGS (global baseline)
  // These are the default values before tier-specific overrides
  // ========================================================================
  var DEFAULT_SHAKE_SETTINGS = {
    hoverTravel: 1.7,
    hoverRotation: 0,
    hoverDuration: 4400,
    hoverStagger: 850,
    shakeSpeed: 105,
    cardTravel: 2,
    cardDuration: 3000,
    cardStagger: 2650,
    popScale: 1.6,
    popDuration: 200,
    popStagger: 50,
    originX: 50,
    originY: 60,
    showOrigin: false,
    fireSideFade: 0.31,
    fireFlameHeight: 0.42,
    fireScale: 0.05,
    fireSpeedY: 0.05,
    fireWobble: 0.05,
    fireThreshold: 1.2,
    fireDetail: 1.2,
    fireAperture: 0.11,
    fireSoftness: 0.143,
    fireAlpha: 1,
    fireColorTop: '#0093fe',
    fireColorMid: '#0093fe',
    fireColorBot: '#00ffff',
    fireOffsetX: 24,
    fireOffsetY: -171,
    fireWidth: 75,
    fireHeight: 195,
    percentTextX: 0,
    percentTextY: 0,
    percentShadowX: 0,
    percentShadowY: 3,
    savingsTextX: -6,
    savingsTextY: -1,
    savingsShadowX: -2,
    savingsShadowY: 7
  };
  
  // ========================================================================
  // DIGITAL UPGRADE MAPPING
  // Maps product titles to their digital upgrade variant IDs
  // ========================================================================
  var DIGITAL_UPGRADE_MAP = {
    'Storyteller Tactics': { variantId: '42474749984857', price: 7900, title: 'Storyteller Tactics Videos & Templates' },
    'Workshop Tactics': { variantId: '42474750017625', price: 7900, title: 'Workshop Tactics Videos & Templates' },
    'Negotiation Tactics': { variantId: '42474750050393', price: 7900, title: 'Negotiation Tactics Videos & Templates' },
    'Copywriting Tactics': { variantId: '42474750083161', price: 7900, title: 'Copywriting Tactics Videos & Templates' },
    'Team Tactics': { variantId: '42474750115929', price: 7900, title: 'Team Tactics Videos & Templates' },
    'Idea Tactics': { variantId: '42474750148697', price: 7900, title: 'Idea Tactics Videos & Templates' },
    'Strategy Tactics': { variantId: '42474750181465', price: 7900, title: 'Strategy Tactics Videos & Templates' },
    'Innovation Tactics': { variantId: '42474750214233', price: 7900, title: 'Innovation Tactics Videos & Templates' },
    'Productivity Tactics': { variantId: '42474750247001', price: 7900, title: 'Productivity Tactics Videos & Templates' },
    'Brand Tactics': { variantId: '42474750279769', price: 7900, title: 'Brand Tactics Videos & Templates' },
    'Retros': { variantId: '42474750312537', price: 7900, title: 'Retros Videos & Templates' },
    'Archetypes': { variantId: '42474750345305', price: 7900, title: 'Archetypes Videos & Templates' }
  };
  
  // Bundle pricing for digital upgrades
  var DIGITAL_BUNDLE_PRICE = 2900;    // £29 as part of bundle
  var DIGITAL_ORIGINAL_PRICE = 7900;  // £79 standalone
  
  // ========================================================================
  // PUBLIC API
  // ========================================================================
  
  /**
   * Get tier intensity settings for a specific tier
   * @param {number|string} tier - Tier index (0-5)
   * @returns {Object} Tier settings
   */
  function getTierSettings(tier) {
    return TIER_INTENSITY[String(tier)] || TIER_INTENSITY["0"];
  }
  
  /**
   * Update a specific tier's settings
   * @param {number|string} tier - Tier index
   * @param {Object} settings - Partial settings to merge
   */
  function updateTierSettings(tier, settings) {
    var tierKey = String(tier);
    if (!TIER_INTENSITY[tierKey]) {
      TIER_INTENSITY[tierKey] = {};
    }
    Object.assign(TIER_INTENSITY[tierKey], settings);
  }
  
  /**
   * Get all tier settings (for export)
   * @returns {Object} All tier intensity settings
   */
  function getAllSettings() {
    return TIER_INTENSITY;
  }
  
  /**
   * Import tier settings (from debug panel)
   * @param {Object} settings - Full TIER_INTENSITY object
   */
  function importSettings(settings) {
    Object.keys(settings).forEach(function(key) {
      TIER_INTENSITY[key] = settings[key];
    });
  }
  
  /**
   * Get digital upgrade data for a product
   * @param {string} productTitle - Product title to look up
   * @returns {Object|undefined} Upgrade data or undefined
   */
  function getDigitalUpgrade(productTitle) {
    return DIGITAL_UPGRADE_MAP[productTitle];
  }
  
  /**
   * Get all digital upgrade mappings
   * @returns {Object} Full mapping object
   */
  function getAllDigitalUpgrades() {
    return DIGITAL_UPGRADE_MAP;
  }
  
  // ========================================================================
  // EXPOSE MODULE
  // ========================================================================
  return {
    // Tier settings
    getTierSettings: getTierSettings,
    updateTierSettings: updateTierSettings,
    getAllSettings: getAllSettings,
    importSettings: importSettings,
    
    // Digital upgrades
    getDigitalUpgrade: getDigitalUpgrade,
    getAllDigitalUpgrades: getAllDigitalUpgrades,
    DIGITAL_BUNDLE_PRICE: DIGITAL_BUNDLE_PRICE,
    DIGITAL_ORIGINAL_PRICE: DIGITAL_ORIGINAL_PRICE,
    
    // Default settings (for reset functionality)
    DEFAULT_SHAKE_SETTINGS: DEFAULT_SHAKE_SETTINGS,
    
    // Direct access (for backwards compatibility and debug panel)
    TIER_INTENSITY: TIER_INTENSITY,
    DIGITAL_UPGRADE_MAP: DIGITAL_UPGRADE_MAP,
    
    // Version
    version: '1.0.0'
  };
})();

// Log that config is loaded
console.log('[BB.TierConfig] Module loaded v' + window.BB.TierConfig.version);








